import React, { useContext } from 'react'
import { t } from 'i18next'
import SpecialistSlots from '../Common/SpecialistSlot'
import SpecialistContext from '../SpecialistContext'
import { Color } from '../../../Common/Color'
import PublicSiderXS from '../../Layouts/Sider/PublicSiderXS'
import SpecialistReason from '../Common/SpecialistReason'
import SpecialistCalendar from '../Common/SpecialistCalendar'
import { Flex } from 'antd'

export default function MobileSpecialist ({ selectSpecialist, selectReason, dateCellRender, headerRender, onSelect, displaySlots }) {
  const { reason, reasons } = useContext(SpecialistContext)

  return (
    <>
      <PublicSiderXS />
      { reason &&
        <div style={{ margin: 'auto', maxWidth: '430px' }}>
          <Flex vertical align='center' style={{ backgroundColor: Color.white }}>
            <SpecialistReason selectSpecialist={selectSpecialist} selectReason={selectReason} />
            <SpecialistCalendar dateCellRender={dateCellRender} headerRender={headerRender} onSelect={onSelect} />
            <SpecialistSlots displaySlots={displaySlots} />
          </Flex>
        </div>
      }
      {reasons?.length === 0 &&
        <div style={{
          boxShadow: '0px 0px 2px 2px #f2f2f2',
          borderRadius: '1em',
          padding: '1em',
          margin: '1em',
          maxWidth: '290px',
          fontSize: '1.2em',
          textAlign: 'center'
        }}>
          <div style={{ color: Color.green, fontWeight: 'bold' }}>
            {t('Public.Specialist.empty')}
          </div>
        </div>
      }
    </>
  )
}
